import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash, faLock } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './Login.css';
import { useNavigate } from 'react-router-dom';
import baseURL from '../../url'; // Ajusta los niveles según la carpeta
import { useUser } from '../UserContext/UserContext'; // Subir 3 niveles hasta src/context

export default function Login() {
    // 1. Estados del formulario (OBLIGATORIOS para corregir los errores no-undef)
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);

    const { loginUser } = useUser();
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();

        try {
            const formData = new FormData();
            formData.append('email', email);
            formData.append('contrasena', password);
            formData.append('iniciar_sesion', true);

            const response = await fetch(`${baseURL}/login.php`, {
                method: 'POST',
                body: formData,
                credentials: 'include',
            });

            if (response.ok) {
                const data = await response.json();
                if (data.mensaje) {
                    toast.success(data.mensaje);
                    
                    // 1. Actualizar el contexto con los datos del usuario
                    if (data.usuario) {
                        loginUser(data.usuario);
                    }

                    // 2. Redirigir/Recargar inmediatamente la ubicación actual
                    // Al ejecutar reload(), MainLayout volverá a ejecutar fetchUsuario(), 
                    // leerá la cookie/sesión activa que acaba de guardar PHP y pintará el <Outlet />
                    setTimeout(() => {
                        window.location.href = '/dashboard';
                    }, 800);

                } else if (data.error) {
                    toast.error(data.error);
                }
            } else {
                throw new Error('Error en la solicitud al servidor');
            }
        } catch (error) {
            toast.error(error.message);
        }
    };

    return (
        <div className='formContain'>
            <ToastContainer />
            <div className='logoAtuh'>
                <FontAwesomeIcon icon={faLock} />
            </div>
            <h2>Iniciar sesión</h2>
            <p>Ingresá tus credenciales para acceder al panel</p>
            <form onSubmit={handleLogin} className='formAuth'>
                <div className='inputsAuth'>
                    <label htmlFor="email">Email</label>
                    <input
                        type="email"
                        id="email"
                        name="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        placeholder="tu@email.com"
                    />
                </div>
                <div className='inputsAuth'>
                    <label htmlFor="password">Contraseña</label>
                    <div className='deFlexInputs'>
                        <input
                            type={showPassword ? 'text' : 'password'}
                            id="password"
                            name="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            placeholder="••••••••"
                        />
                        <button
                            type="button"
                            onClick={() => setShowPassword(!showPassword)}
                            tabIndex={-1}
                        >
                            <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                        </button>
                    </div>
                </div>

                <button type="submit" className='btn'>
                    Iniciar Sesión
                </button>
            </form>
        </div>
    );
}